<div class="overlay">
    <div class="content center-content" #notificationContainer>
        <div class="column-flex">
            <div class="title" data-cy="notification-modal-header">
                {{ data.title | translate }}
            </div>
            <div class="message-container">
                <div class="message" data-cy="notification-modal-body-ok">
                    {{ data.message | translate }}
                </div>
                <div class="message" data-cy="notification-modal-body-ng" *ngIf="data.message2">
                    {{ data.message2 | translate }}
                </div>
            </div>
            <div class="buttons-container">
                <div class="button" data-cy="notification-modal-button" (click)="closeNotification()">
                    {{ data.closeButton | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
